import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useDataAggregation } from '../../Common/hooks/useAggregationData';
import { useConditionalityChartsDataContext } from './hooks/useConditionalityChartsDataContext';
import { getMonthLabel } from '../../../Common/Util/getMonthLabel'

export const WithInformedHealthConditionsComparisonPercentageMonthly = () => {
    const { chartData } = useConditionalityChartsDataContext();

    const rawData = chartData?.withInformedHealthConditionsComparisonPercentageMonth || [];

    const formattedValues = rawData?.map((item) => {
        const value = Number(item.percentage);
        return isNaN(value) ? 0 : value;
    });

    const isYearComparison = rawData.length > 0 && rawData.every(item => item.mes === rawData[0].mes);
    const formattedSubtitles = isYearComparison ? rawData.map(item => `${getMonthLabel(item.mes)}/${item.ano}`): rawData.map(item => getMonthLabel(item.mes));
    
    return (
        <SimpleBars
            title={'Comparação de Condições de Saúde Informadas - Percentual (Mensal)'}
            horizontal={false}
            subtitles={formattedSubtitles}
            values={formattedValues}
        />
    );
};